import { EVENT_EMITTER_TOKEN, EventDelegate } from "./EventDelegate";
export class AsyncEventDelegate extends EventDelegate {
  constructor(...args) {
    super(...args);
    this._eventEmitter = new EVENT_EMITTER_TOKEN.value(true);
  }

}
